import {
  AppHeader,
  AppHeaderBackButton,
  AppHeaderLinearProgress,
  Typography,
} from '@ace-clublabs/shared-component-library';

export interface AppHeaderProgressProps {
  description: string;
  currentStep: number;
  totalSteps: number;
  percentage: number;
  styleOverrides?: object;
}
export const AppProgressHeader: (props: AppHeaderProgressProps) => JSX.Element = ({
  description,
  currentStep,
  totalSteps,
  percentage,
  styleOverrides,
}) => {
  return (
    <AppHeader
      backButton={<AppHeaderBackButton />}
      progress={<AppHeaderLinearProgress value={percentage} aria-label="progress" />}
      sx={{ padding: 0, ...styleOverrides }}
      navigation={
        <Typography variant="b3Regular" className="step-indicator" sx={{ color: '#3D4043 !important' }}>
          Step {currentStep}/{totalSteps}: {description}
        </Typography>
      }
    />
  );
};
